const prodEnv = process.env.NEXT_PUBLIC_API_URL_PROD;
const devEnv = process.env.NEXT_PUBLIC_API_URL_DEV;
const variantEnv = process.env.NEXT_PUBLIC_BACKEND_VARIANT;

function stripTrailingSlash(s: string) {
  return s.replace(/\s+$/g, "").replace(/\/+$/, "");
}

function deriveWsUrl(httpUrl: string) {
  if (!httpUrl) return "";
  if (httpUrl.startsWith("https://")) return httpUrl.replace(/^https:/, "wss:");
  if (httpUrl.startsWith("http://")) return httpUrl.replace(/^http:/, "ws:");
  return "";
}

let chosenRaw: string = "";
const defaultVariant = process.env.NODE_ENV === "production" ? "prod" : "dev";
const variant = (variantEnv ?? defaultVariant).toLowerCase();

if (variant === "prod") {
  chosenRaw = prodEnv ?? "";
} else if (variant === "dev") {
  chosenRaw = devEnv ?? "";
}

if (!chosenRaw) {
  if (typeof window === "undefined") {
    console.warn(
      "NEXT_PUBLIC_API_URL_PROD (or NEXT_PUBLIC_API_URL_DEV) not set. API_URL will be empty.",
    );
  } else {
    console.error(
      "NEXT_PUBLIC_API_URL_PROD (or NEXT_PUBLIC_API_URL_DEV) not set. Please set it in your environment.",
    );
  }
}

export const API_URL = stripTrailingSlash(chosenRaw);
export const WS_API_URL = deriveWsUrl(API_URL);

/**
 * Explicit override for the LiveKit signalling URL the browser dials.
 *
 * **Normally unset.** The authoritative value is the voice-token mint's own
 * `url`: ai-gateway keeps `livekit_url` (public, what it returns) separate from
 * `livekit_internal_url` (what the worker dials), so the mint never hands back
 * an internal address. This exists only for an environment whose mint has no
 * public URL configured yet.
 */
export const LIVEKIT_WS_URL = stripTrailingSlash(
  process.env.NEXT_PUBLIC_LIVEKIT_URL ?? "",
);

/**
 * Last-resort LiveKit URL — the `/livekit` path an nginx front-end serves in
 * the deployment. Used **only** when the mint returns no url, so a deployment
 * that predates `livekit_url` keeps working.
 *
 * Never reach for this first. `/livekit` exists only in front of the
 * deployment: the local mesh has no such route (api-gateway carries no LiveKit
 * upstream), so its catch-all WS handler accepts the signal socket and closes
 * it with nothing behind it — which surfaces as livekit-client's "could not
 * establish signal connection: Websocket got closed during a (re)connection
 * attempt". Preferring this over the mint's url is what broke voice locally.
 */
export const LIVEKIT_FRONTED_FALLBACK_URL = WS_API_URL
  ? `${WS_API_URL}/livekit`
  : "";
